import React from "react";
import {
  FormControlLabel,
  styled,
  Switch,
  SwitchProps,
  Typography,
} from "@mui/material";

interface SwitchToggleProps {
  checked?: boolean;
  defaultChecked?: boolean;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  label?: React.ReactNode;
  showStatusLabel?: boolean;
  disabled?: boolean;
}

const IOSSwitch = styled((props: SwitchProps) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 34,
  height: 18,
  overflow: 'visible',
  padding: 0,

  "& .MuiSwitch-switchBase": {
    padding: 0,
    transitionDuration: "300ms",
    transform: "translateX(3px) translateY(3px)",
    margin: 0,

    "&.Mui-checked": {
      transform: "translateX(19px) translateY(3px)",
      color: "#fff",

      "& + .MuiSwitch-track": {
        backgroundColor: "#0CD0C6",
        opacity: 1,
        border: 0,
      },
    },
  },

  "& .MuiSwitch-thumb": {
    width: 12,
    height: 12,
    backgroundColor: "#ffffff",
  },

  "& .MuiSwitch-track": {
    borderRadius: 11,
    backgroundColor: "#e0e0e0",
    opacity: 1,
    transition: theme.transitions.create(["background-color"], {
      duration: 300,
    }),
  },
}));

const SwitchToggle: React.FC<SwitchToggleProps> = ({
  checked,
  defaultChecked = false,
  onChange,
  label,
  showStatusLabel = false,
  disabled = false,
}) => {
  const isControlled = typeof checked === "boolean";

  const [internalChecked, setInternalChecked] =
    React.useState(defaultChecked);

  const value = isControlled ? checked : internalChecked;

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!isControlled) {
      setInternalChecked(e.target.checked);
    }
    onChange?.(e);
  };

  return (
    <FormControlLabel
      sx={{ gap: 1 }}
      control={
        <IOSSwitch
          checked={value}
          onChange={handleChange}
          disabled={disabled}
        />
      }
      label={
        label ||
        (showStatusLabel && (
          <Typography
            variant="body2"
            className={value ? "text_success" : "text_danger"}
          >
            {value ? "Active" : "Inactive"}
          </Typography>
        ))
      }
    />
  );
};

export default SwitchToggle;
